<script lang="ts">
  import { onMount } from 'svelte';
  import { DataHandler, type Row, type State } from '@vincjo/datatables/remote';
  import { entityStore, uiState, setUIState, setEntityId } from '$lib/stores/entityStore';
  import RowsPerPage from '$lib/components/datatable/RowsPerPage.svelte';
  import Pagination from '$lib/components/datatable/Pagination.svelte';
  import { ColumnNames } from '$lib/models/entity/types';
  import { createSearchTableStore } from '$lib/stores/searchTableStore';
  import IconButton from '$lib/components/common/iconButton/IconButton.svelte';
  
  export let clientId: number;
  
  const tableStore = createSearchTableStore('client-entity', ColumnNames.Id);
  const localTableData = tableStore.get();
  let dataHandler = new DataHandler<Row>([], {
    rowsPerPage: localTableData.pageSize,
    totalRows: 1,
  });
  let selectedFilters: string[] = [];
  const rows = dataHandler.getRows();
  
  dataHandler.applySort({
    orderBy: localTableData.sort.orderBy,
    direction: localTableData.sort.direction,
  });
  localTableData.filters.kvp?.map((x) => {
    dataHandler.filter(x.value, x.key);
    selectedFilters = [...selectedFilters, x.key];
  });
  if (localTableData.filters.search) {
    dataHandler.filter(localTableData.filters.search, ColumnNames.Name);
  }

  dataHandler.onChange(async (state: State) => {
    const result = await entityStore.fetchForClient(clientId, state);
    const total: number = result.total > 0 ? result.total : 1;
    dataHandler.setTotalRows(total);
    return result.data;
  });
  dataHandler.invalidate();
  
  onMount(async () => {
    dataHandler.onChange(async (state: State) => {
      const result = await entityStore.fetchForClient(clientId, state);
      const total: number = result.total > 0 ? result.total : 1;
      dataHandler.setTotalRows(total);
      return result.data || [];
    });
    dataHandler.invalidate();
  });

  async function handleEdit(row: Row): Promise<void> {
    setUIState('UpdateEntityPage');
    setEntityId(row.id);
  }
</script>

<div class="ml-5 mr-5 mt-5 rounded-3xl border-2 border-surface-600 bg-white bg-opacity-90 p-4 lg:ml-0">
  <div class="mx-auto flex flex-col p-4">
    <div class="table-container h-auto overflow-x-auto rounded-2xl rounded-bl-none rounded-br-none border border-b-0 border-[--tableBorder]">
      <table class="table table-hover table-auto rounded-2xl rounded-bl-none rounded-br-none lg:table-fixed">
        <thead class="!bg-[--tableHeaderBackground]">
          <tr>
            <th class="!text-md h-[39px] w-[10%] !p-5 !font-medium leading-3 text-[--tableHeaderFont]">ID</th>
            <th class="!text-md h-[39px] w-[30%] !p-5 !font-medium leading-3 text-[--tableHeaderFont]"> Name </th>
            <th class="!text-md h-[39px] w-[25%] !p-5 !font-medium leading-3 text-[--tableHeaderFont]"> Entity Key </th>
            <th class="!text-md h-[39px] w-[25%] !p-5 !font-medium leading-3 text-[--tableHeaderFont]"> Entity Product Key </th>
            <th class="!text-md h-[39px] w-[10%] !p-5 !font-medium leading-3 text-[--tableHeaderFont]"></th>
          </tr>
        </thead>
        <tbody>
          {#each $rows as row}
            <tr class="!border-[--tableBorder]">
              <td class="h-10 w-[10%] content-center !px-5">
                <div class="text-md center flex items-center font-bold text-primary-500">
                  {row.id}
                </div>
              </td>
              <td class="w-[30%] cursor-pointer content-center !px-5" on:click={() => handleEdit(row)}>
                <div class="text-md center block items-center overflow-hidden text-ellipsis whitespace-nowrap font-bold text-primary-500">
                  {row.name}
                </div>
              </td>
              <td class="w-[25%] content-center !px-5">
                <div class="text-md items-center font-normal text-primary-500">
                  {row.entityKey}
                </div>
              </td>
              <td class="w-[25%] content-center !px-5">
                <div class="text-md flex items-center font-normal text-primary-500">
                  {row.entityProductKey}
                </div>
              </td>
              <td class="w-[10%] content-center">
                <div>
                  <IconButton icon="edit" displayBorder={true} onClick={() => handleEdit(row)} />
                </div>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
    <div class="mt-5 inline-flex w-full justify-between">
      <RowsPerPage handler={dataHandler} store={tableStore} />
      <Pagination handler={dataHandler}></Pagination>
    </div>
  </div>
</div>
